import type { LessonCourse, LessonMove, LessonNode } from "./schema.ts";

export function walkRepertoire(course: LessonCourse): { sans: string[]; nodes: LessonNode[] } {
  const sans: string[] = [];
  const nodes: LessonNode[] = [];
  let node = course.nodes[course.rootPositionKey];
  while (node) {
    nodes.push(node);
    const next = node.moves.find((m) => m.role === "repertoire" || m.role === "mainline") || null;
    if (!next) break;
    sans.push(next.san);
    node = course.nodes[next.nextPositionKey];
  }
  return { sans, nodes };
}

export function whiteRepertoireMoves(
  course: LessonCourse
): { after: string[]; san: string; move: LessonMove }[] {
  const out: { after: string[]; san: string; move: LessonMove }[] = [];

  function visit(key: string, after: string[], seen: Set<string>) {
    if (seen.has(key)) return;
    seen.add(key);
    const node = course.nodes[key];
    if (!node) return;
    const whiteToMove = after.length % 2 === 0;
    for (const move of node.moves) {
      if (whiteToMove && (move.role === "repertoire" || move.role === "transposition")) {
        out.push({ after, san: move.san, move });
      }
      visit(move.nextPositionKey, [...after, move.san], seen);
    }
  }

  visit(course.rootPositionKey, [], new Set());
  return out;
}

export function namedBranches(course: LessonCourse): string[] {
  const { nodes: mainNodes } = walkRepertoire(course);
  const mainKeys = new Set(mainNodes.map((n) => n.positionKey));
  const names = new Set<string>();
  for (const node of Object.values(course.nodes)) {
    if (node.variationName && !mainKeys.has(node.positionKey)) names.add(node.variationName);
  }
  return [...names].sort();
}

export function tacticalWarningCount(course: LessonCourse): number {
  let count = 0;
  for (const node of Object.values(course.nodes)) {
    for (const move of node.moves) if (move.tacticalWarning) count += 1;
  }
  return count;
}
